require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./double-diplme-et-masters-conjoints-2-5-2.json") })
        }
      }, "path---double-diplme-et-masters-conjoints-2-5-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---double-diplme-et-masters-conjoints-2-5-2!./.cache/json/double-diplme-et-masters-conjoints-2-5-2.json
// module id = 397
// module chunks = 231608221292675